import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PrivacyTextIntegration = styled.div.withConfig({
  displayName: "CustomTermsAndConditions__PrivacyTextIntegration",
  componentId: "sc-1l0rnke-0"
})(["margin-bottom:", ";margin-top:", ";line-height:", ";"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.typography['body-200'].lineHeight);
export const StyledPrivacyBanner = styled.div.withConfig({
  displayName: "CustomTermsAndConditions__StyledPrivacyBanner",
  componentId: "sc-1l0rnke-1"
})(["margin-top:", ";", ""], ({
  theme
}) => theme.space['500'], props => props.theme.embedded && `margin-top: ${props.theme.space['100']};`);
export const CustomTermsAndConditions = ({
  children,
  LegitimateInterest
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      children: /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [/*#__PURE__*/_jsx(PrivacyTextIntegration, {
          children: children
        }), LegitimateInterest]
      })
    })
  });
};